import { useQuery } from '@tanstack/react-query';
import { fetchRoles } from './helper';

export const useRolesQuery = (userAccessToken: string, userRole: string) => {
  return useQuery({
    queryKey: ['roles', userRole],
    queryFn: () =>
      fetchRoles({
        userAccessToken,
        userRole
      }),
    enabled: Boolean(userAccessToken && userRole),
    staleTime: 5 * 60 * 1000 // 5 minutes cache
  });
};
